module.exports = __webpack_public_path__ + "img/sample_04_big.2ac81337.gif";